/**
 * uploadImg.js
 *
 * @Author: zhangce
 * @Date: 17/9/22 下午3:11
 */
import axios from 'axios';
import ajax from './ajax';
import nosConfig from './nosConfig';

const uploadImg = (file, onSuccess, onFail, config = {}) => {
  const { watermark, wmImage, naturalWidth, name, onUploadProgress, noModal, max } = config;
  if (!file || !file.size) {
    const error = new Error();
    error.msg = '文件不存在';
    return onFail(error);
  }
  if (max && file.size >= max) {
    const error = new Error();
    error.msg = '文件大小不可以超过5M';
    return onFail(error);
  }
  let wmWidth = 0;
  if (watermark && wmImage) {
    for (const width in wmImage) {
      if (naturalWidth >= +width && wmWidth < +width) {
        wmWidth = +width;
      }
    }
  }
  const data = new FormData();
  const type = file.type || 'image/jpeg';
  data.append('file', file, name || file.name);
  data.append('uploadtype', nosConfig.uploadtype);
  data.append('from', nosConfig.from);
  data.append('bucketName', nosConfig.bucketName);

  if (watermark && type === 'image/jpeg' && wmImage[wmWidth]) {
    data.append('watername', wmImage[wmWidth]);
    data.append('position', 'southeast');
  }

  return ajax(
    `//${nosConfig.domain}/api/v2/upload/nos/water`,
    {
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
      onUploadProgress,
    },
    onSuccess,
    onFail,
    noModal,
  );
};

const uploadEncyptImg = file => {
  const data = new FormData();
  data.append('file', file);
  data.append('from', nosConfig.FROM);
  return axios.post('//upfile.m.163.com/nos/upload/pub/aes?requireHttps=true', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }).then(rs => {
    const { status, data: resData } = rs;
    if (status === 200 && resData.status === 1) {
      const { url } = resData;
      return Promise.resolve(url);
    }
    return Promise.reject();
  })
};

export { uploadEncyptImg };

export default uploadImg;
